import { render, staticRenderFns } from "./legalInspection.vue?vue&type=template&id=064acfc1&scoped=true"
import script from "./legalInspection.vue?vue&type=script&lang=js"
export * from "./legalInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064acfc1",
  null
  
)

export default component.exports